import React from "react";
import "./SearchTopActions.scss";

export const SearchTopActions: React.FC = ({ children }) => (
  <div className="search-top-actions">{children}</div>
);
